<template>
  <p>enviando a ciudadania...</p>
</template>
<script>
import Auth from './mixins/auth';

export default {
  created () {
    this.getCode();
  },
  mixins: [ Auth ]
};
</script>



// WEBPACK FOOTER //
// src/components/admin/auth/LoginDjbr.vue